import { CButton, CModal, CModalBody, CModalFooter } from '@coreui/react';
import React, { useState } from 'react';
import Headline from '../../../../../../general/Headline';

const StepRuleName = React.lazy(() => import('../steps/StepRuleName'));
const StepSelectConditionFields = React.lazy(() => import('../steps/StepSelectConditionFields'));

const CreateNewFormRuleSteps = () => {
     const [stepsData, setStepsData] = useState({
          name: '',
          description: '',
          conditions: [],
          customVariables: [[{ id: '' }]],
          group: 'formRule',
     });

     return (
          <>
               <StepRuleName stepsData={stepsData} setStepsData={setStepsData} RuleContext={FormRuleContext} mode="create" />
               <StepSelectConditionFields stepsData={stepsData} setStepsData={setStepsData} RuleContext={FormRuleContext} mode="create" />
          </>
     );
};

export const FormRuleContext = React.createContext({});

const CreateNewFormRule = () => {
     const [modal, setModal] = useState(false);
     const [activeStep, setActiveStep] = useState(2);

     return (
          <div className="rule-detail">
               <Headline title="Create New Form Rule">
                    <p>Write rules to push custom data into your data layer.</p>
               </Headline>

               <div className="cvr-create-new custom-rule">
                    <FormRuleContext.Provider value={{ activeStep, setActiveStep }}>
                         <CreateNewFormRuleSteps />
                    </FormRuleContext.Provider>

                    <CModal visible={modal} alignment="center" portal={false} onClose={() => setModal(false)}>
                         <CModalBody className="text-center">
                              <h3 className="mb-4">Warning! This Will Change Your Rule</h3>
                              <p>
                                   You are about to change your rule type. Doing this will reset and remove all settings inside this rule other than
                                   the name and description.
                              </p>
                              <p>Are you sure you want to do this? You cannot undo this once you publish it!</p>
                         </CModalBody>
                         <CModalFooter className="text-center justify-content-center">
                              <CButton color="primary" className="mr-3 text-uppercase" onClick={() => setModal(false)}>
                                   Cancel
                              </CButton>
                              <CButton color="secondary" onClick={() => { }}>
                                   Save Change and Reset Rule
                              </CButton>
                         </CModalFooter>
                    </CModal>
               </div>
          </div>
     );
};

export default CreateNewFormRule;
